<template>
  <div>
    <!-- Botão Adicionar Patrimonio -->
    <div class="my-5">
      <vs-button
        type="border"
        class="buttonStyle"
        icon="add"
        icon-after
        @click="adicionaPatrimonio"
        v-if="!modeAnalise"
        >Adicionar Patrimônio</vs-button
      >
    </div>

    <div slot="header">
      <h3 class="my-5">Patrimônios</h3>
    </div>

    <!-- Lista Patrimônios em Desktop-->
    <div v-if="patrimonios.length > 0" class="showDesktop">
      <table class="w-full">
        <thead>
          <th>Protocolo</th>
          <th>Nome</th>
          <th>Telefone</th>
          <th>Endereço</th>
          <th class="text-center">Ação</th>
        </thead>
        <tbody>
          <tr v-for="patrimonio in patrimonios" :key="patrimonio.idEnvolvido">
            <td>{{ patrimonio.protocolo }}</td>
            <td>{{ patrimonio.nome }}</td>
            <td>{{ patrimonio.telefone }}</td>
            <td>{{ patrimonio.endereco }}</td>
            <td class="text-center flex gap-3 justify-center">
              <vs-button
                radius
                color="warning"
                size="small"
                class="text-lg"
                icon="edit"
                @click="redirecionaTelaEdit(patrimonio.idEnvolvido)"
              />
              <vs-button
                radius
                color="danger"
                size="small"
                class="text-lg"
                icon="delete"
                v-if="!modeAnalise"
                @click="openModalDelete(patrimonio)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Lista Patrimonios em mobile -->
    <vs-collapse v-if="patrimonios.length > 0" class="showMobile">
      <vs-collapse-item
        v-for="patrimonio in patrimonios"
        :key="patrimonio.idEnvolvido"
      >
        <div slot="header">
          <p><b>Protocolo:</b> {{ patrimonio.protocolo }}</p>
          <p><b>Nome:</b> {{ patrimonio.nome }}</p>
        </div>
        <div>
          <p>
            <b>Telefone:</b>
          </p>
          {{ patrimonio.telefone }}
          <p>
            <b>Placa:</b>
          </p>
          {{ patrimonio.placa }}
          <p>
            <b>Endereço:</b>
          </p>
          {{ patrimonio.endereco }}

          <p class="flex justify-center mt-3 gap-3">
            <vs-button
              @click="redirecionaTelaEdit(patrimonio.idEnvolvido)"
              color="warning"
              size="small"
              class="text-lg w-full"
              >Editar</vs-button
            >
            <vs-button
              color="danger"
              size="small"
              class="text-lg w-full"
              v-if="!modeAnalise"
              @click="openModalDelete(patrimonio)"
              >Deletar</vs-button
            >
          </p>
        </div>
      </vs-collapse-item>
    </vs-collapse>

    <!-- Modal Deletar patrimonio -->
    <Modal :active.sync="modalDeleteAtivo" :title="'Confirmar'">
      <div>
        <div>
          <h5>Certeza de que deseja apagar os dados do patrimônio?</h5>
          <div v-if="patrimonioSelecionado" class="m-5">
            <p>
              <b>Nome:</b>
              {{
                patrimonioSelecionado.nome
                  ? patrimonioSelecionado.nome
                  : 'não consta'
              }}
            </p>
            <p>
              <b>Telefone:</b>
              {{
                patrimonioSelecionado.telefone
                  ? patrimonioSelecionado.telefone
                  : 'não consta'
              }}
            </p>
            <p>
              <b>Protocolo:</b>
              {{
                patrimonioSelecionado.protocolo
                  ? patrimonioSelecionado.protocolo
                  : 'não consta'
              }}
            </p>
            <p>
              <b>Placa:</b>
              {{
                patrimonioSelecionado.placa
                  ? patrimonioSelecionado.placa
                  : 'não consta'
              }}
            </p>
            <p>
              <b>Marca:</b>
              {{
                patrimonioSelecionado.veiculoMarca
                  ? patrimonioSelecionado.veiculoMarca
                  : 'não consta'
              }}
            </p>
            <p>
              <b>Modelo:</b>
              {{
                patrimonioSelecionado.modelo
                  ? patrimonioSelecionado.veiculoModelo
                  : 'não consta'
              }}
            </p>
          </div>
          <vs-alert
            v-if="patrimonioSelecionado"
            title="Atenção"
            active="true"
            color="danger"
            class="mb-2"
          >
            <p>
              Ao apagar os dados do patrimônio, você irá perder todas as
              informações, além de fotos e documentos que estão anexados ao
              patrimônio.
            </p>
            <p>Essa ação não pode ser revertida.</p>
          </vs-alert>
        </div>
        <div class="flex justify-end gap-3">
          <vs-button
            color="primary"
            class="text-lg"
            @click="modalDeleteAtivo = false"
            >Cancelar</vs-button
          >

          <vs-button
            color="danger"
            class="text-lg"
            @click="deletaPatrimonio(patrimonioSelecionado.idEnvolvido)"
            >Deletar</vs-button
          >
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import eventoService from './../service';
import notify from './../../../../../utils/notify';
import Modal from '../../../../../components/Modal.vue';

export default {
  props: ['idEvento', 'patrimonios', 'modeAnalise'],
  components: { Modal },
  data() {
    return {
      modalDeleteAtivo: false,
      patrimonioSelecionado: null,
    };
  },
  methods: {
    redirecionaTelaEdit(idEnvolvido) {
      const route = `/editar-eventos-patrimonio/${this.idEvento}/${idEnvolvido}`;
      this.$router.push(route);
    },
    async adicionaPatrimonio() {
      try {
        this.$vs.loading();
        const result = await eventoService.postTerceiro(this.idEvento, 'P');
        this.redirecionaTelaEdit(result.idEnvolvido);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async deletaPatrimonio(idEnvolvido) {
      try {
        this.$vs.loading();
        await eventoService.softDeleteTerceiro(idEnvolvido);

        // eslint-disable-next-line vue/no-mutating-props
        this.patrimonios = this.patrimonios.filter(
          (x) => x.idEnvolvido !== idEnvolvido,
        );

        this.modalDeleteAtivo = false;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    openModalDelete(patrimonio) {
      this.modalDeleteAtivo = true;
      this.patrimonioSelecionado = patrimonio;
    },
  },
};
</script>

<style scoped>
.buttonStyle {
  font-weight: 500;
  display: flex;
  justify-content: space-around;
}

.buttonStyle > span {
  display: flex;
  justify-content: space-around;
}
.showDesktop {
  display: block;
}

.showMobile {
  display: none;
}

@media (max-width: 500px) {
  .showDesktop {
    display: none;
  }

  .showMobile {
    display: block;
  }
}
</style>
